export default {
  getValidations: (state) => {
    return state.validations;
  },
}
